import { render, staticRenderFns } from "./F130SlotsEdit.vue?vue&type=template&id=9a536238"
import script from "./F130SlotsEdit.vue?vue&type=script&lang=js"
export * from "./F130SlotsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports